export default __webpack_public_path__ + "static/media/card2400.8c1c2bca.jpg";